import styled from "@emotion/styled";

import { fontRoboto, theme } from "shared/lib/styles";

export const Container = styled.div`
  font-size: 20px;
  font-family: ${fontRoboto};
  line-height: 23.44px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  margin-block-start: 4px;

  ${theme.breakpoints.up("tablet")} {
    display: inline-flex;

    margin-block-start: 0;
  }
`;

export const TopicTitle = styled.b`
  font-size: 18px;
  line-height: 21px;
`;
